module.exports = __webpack_public_path__ + "img/menu_mens_ibiki.f087c4cf.webp";